<div #abstractReferenceId class="bdg-hover-btn-overlay">
  <button [disabled]="disabled" mat-icon-button>
    <mat-icon>{{ icon }}</mat-icon>
  </button>
</div>
